
import React from "react";
import { TrendingUp } from "lucide-react";
import "./BudgetCard.css";

const BudgetCard = ({
  title,
  icon: Icon,
  type,
  limit,
  spent,
  available,
}) => {
  const percent = (spent / limit) * 100;

  return (
    <div className="budget-card">
      <div className="budget-header">

        <h4 style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {Icon && <Icon size={16} />}
          {title}
        </h4>

        <span className="budget-type">{type}</span>
      </div>

      <div className="budget-limit">
        <TrendingUp size={14} style={{ marginRight: "4px" }} />
        {type === "One time" ? "Budget Limit" : "Group Limit"}: {limit.toLocaleString()}
      </div>

      <div className="budget-bar">
        <div
          className="budget-progress"
          style={{ width: `${percent}%` }}
        ></div>
      </div>

      <div className="budget-footer">
        <div className="spent">
          <span className="dot black"></span>
          SPENT
          <div className="value">{spent.toLocaleString()}</div>
        </div>

        <div className="available">
          <span className="dot green"></span>
          AVAILABLE
          <div className="value green">
            {available.toLocaleString()}
          </div>
        </div>

      </div>
    </div>
  );
};

export default BudgetCard;